export const styles = {
  icon: 'w-2xl h-2xl rounded-md',
};
